import { Result } from '@empathy/search-types';
import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_GETTERS_KEYS } from '../recommendations.const';
import { RecommendationsGetter } from '../recommendations.interfaces';

export class TopRecommendationsGetter implements RecommendationsGetter {
  getters = {
    [RECOMMENDATIONS_GETTERS_KEYS.topRecommendations]: (state: RecommendationsState): Result[] =>
      state.recommendations
  };
}
